import cn from '@/lib/cs';
import React from 'react';

const SearchIcon = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		aria-hidden
		className={cn('h-8 lg:h-12 pointer-events-none', className)}
		{...props}
	>
		<g clipPath="url(#a)">
			<path
				fill="currentColor"
				d="M24 22.5c-.2-.7 0-1.5-.5-2-2-1.5-3.4-3.6-5.4-5-.6-1.1 1.2-2.4.9-3.6C20.5 4 14.7-.4 8 0a11.7 11.7 0 0 0-8 9.3c-.5 3.3 2.1 6 3.6 8.7 2 1.9 5.7 2.2 8.3 1.1 1-.4 2.2-.4 3-1.2.1-.2.2 0 .3 0 2.2 1.9 3.8 4.6 6.3 6 .7.4 2.2-.8 2.5-1.4Zm-7.7-10.7c-1.7 4-7.1 7.2-10.8 3.8-2.8-4-3.5-6.9-.2-11 5-4 13.2.6 11 7.2Z"
			/>
		</g>
		<defs>
			<clipPath id="a">
				<path fill="currentColor" d="M0 0h24v24H0z" />
			</clipPath>
		</defs>
	</svg>
);

export default SearchIcon;
